/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgChartParallelCoordinates = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M4 2v4.584L6.926 3.66 11 6.92V2h2v4.584l2.926-2.924L20 6.92V2h2v20h-2v-4.921L16.35 20H13v2h-2v-2.52l-3.926-3.14L4 19.414V22H2V2zm16 11h-7v5h2.649L20 14.519zm-9 0H4v3.584l2.926-2.924L11 16.92zM7.074 6.34 4 9.414V11h7V9.48zm9 0L13 9.414V11h7V9.48z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgChartParallelCoordinates as ChartParallelCoordinates };
